package com.mgacreative.hotel.feature.admin.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material.icons.filled.Description
import androidx.compose.material.icons.filled.Print
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.mgacreative.hotel.domain.model.Agency
import com.mgacreative.hotel.shared.ui.designsystem.components.HFCard
import com.mgacreative.hotel.shared.ui.designsystem.components.verticalScrollbar
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun AgencyContractScreen(
    onNavigateBack: () -> Unit
) {
    val adminViewModel = koinViewModel<AdminViewModel>()
    val agencyViewModel = koinViewModel<AdminAgencyViewModel>()

    val hotelProfile by adminViewModel.profile.collectAsState()
    val agencies by agencyViewModel.agencies.collectAsState()

    LaunchedEffect(Unit) {
        adminViewModel.loadDashboardData()
        agencyViewModel.loadData()
    }

    var selectedAgency by remember(agencies) { mutableStateOf<Agency?>(agencies.firstOrNull()) }
    var expandedDropdown by remember { mutableStateOf(false) }

    // Manuel Doldurulacak Sözleşme Parametreleri
    var startDate by remember { mutableStateOf("01.05.2026") }
    var endDate by remember { mutableStateOf("31.10.2026") }
    var allottedRooms by remember { mutableStateOf("10 Oda") }
    var roomType by remember { mutableStateOf("Standart Tip") }
    var boardType by remember { mutableStateOf("Her Şey Dahil") }
    var commissionRate by remember(selectedAgency) { 
        mutableStateOf(selectedAgency?.commissionRate?.toString() ?: "15") 
    }
    var actionDiscount by remember { mutableStateOf("Yoktur") }
    var releaseDays by remember { mutableStateOf("7") }
    var stopSaleDays by remember { mutableStateOf("3") }
    var cancellationDays by remember { mutableStateOf("3") }
    var paymentTerm by remember { mutableStateOf("Haftalık Fatura Karşılığı") }
    var courtCity by remember { mutableStateOf("İstanbul") }
    var contractDate by remember { mutableStateOf("26.07.2026") }

    // Özel Hükümler (Manuel Metin Alanı)
    var specialConditions by remember { 
        mutableStateOf("1. ACENTE, otelin belirlediği fiyat politikası haricinde internet ortamında düşük fiyat garantisi veremez.\n2. Sezon ortası kontenjan artırımı tarafların yazılı onayı ile yapılır.") 
    }

    val clipboardManager = LocalClipboardManager.current
    var showSnackbar by remember { mutableStateOf(false) }

    // Otel Bilgileri
    val hotelName = hotelProfile?.name ?: "HOTEL OS AKDENİZ RESORT"
    val hotelCompanyTitle = hotelProfile?.companyTitle ?: hotelName
    val hotelAddress = hotelProfile?.address ?: "Antalya Mah. Sahil Cad. No:1 Kemer / Antalya"
    val hotelTaxOffice = hotelProfile?.taxOffice ?: "Kemer VD"
    val hotelTaxNumber = hotelProfile?.taxNumber ?: "1234567890"
    val hotelAuthorizedPerson = hotelProfile?.authorizedPerson ?: "Ahmet Yılmaz (Genel Müdür)"
    val hotelContact = "${hotelProfile?.phone ?: "+90 242 123 45 67"} / ${hotelProfile?.email ?: "info@hotelos.com"}"

    // Acente Bilgileri
    val agencyName = selectedAgency?.name ?: "Örnek Turizm A.Ş."
    val agencyCompanyTitle = selectedAgency?.name ?: agencyName
    val agencyTursabNo = selectedAgency?.tursabNo ?: "A-1234"
    val agencyAddress = selectedAgency?.address ?: "Atatürk Cad. No:45 Çankaya / Ankara"
    val agencyTaxOffice = selectedAgency?.taxOffice ?: "Çankaya VD"
    val agencyTaxNumber = selectedAgency?.taxNumber ?: "9876543210"
    val agencyAuthorizedPerson = selectedAgency?.authorizedPerson ?: "Mehmet Demir (Acente Müdürü)"
    val agencyContact = "${selectedAgency?.phone ?: "+90 312 987 65 43"} / ${selectedAgency?.email ?: "rezervasyon@ornekturizm.com"}"

    // Oluşturulan Tam Sözleşme Metni
    val fullContractText = remember(
        hotelName, hotelAddress, hotelTaxOffice, hotelTaxNumber, hotelAuthorizedPerson, hotelContact,
        agencyName, agencyTursabNo, agencyAddress, agencyTaxOffice, agencyTaxNumber, agencyAuthorizedPerson, agencyContact,
        startDate, endDate, allottedRooms, roomType, boardType, commissionRate, actionDiscount,
        releaseDays, stopSaleDays, cancellationDays, paymentTerm, courtCity, contractDate, specialConditions
    ) {
        """
OTEL İLE ACENTE ARASINDA KONTENJAN VE ÖZEL İNDİRİM SÖZLEŞMESİ

1. TARAFLAR
1.1. OTEL (Hizmet Sağlayıcı):
Ünvanı: $hotelCompanyTitle
Adresi: $hotelAddress
Vergi Dairesi / No: $hotelTaxOffice / $hotelTaxNumber
Yetkili: $hotelAuthorizedPerson
İletişim: $hotelContact

1.2. ACENTE (Aracı):
Ünvanı: $agencyCompanyTitle
TÜRSAB Belge No: $agencyTursabNo
Adresi: $agencyAddress
Vergi Dairesi / No: $agencyTaxOffice / $agencyTaxNumber
Yetkili: $agencyAuthorizedPerson
İletişim: $agencyContact

2. SÖZLEŞMENİN KONUSU
İşbu sözleşmenin konusu; OTEL’in, ACENTE’ye belirtilen tarih aralığında tahsis ettiği oda kontenjanları, bu kontenjanlara uygulanacak özel indirim oranları, satış/ödeme koşulları ve tarafların karşılıklı hak ve yükümlülüklerinin belirlenmesidir.

3. KONTENJAN, TARİH ARALIĞI VE FİYATLANDIRMA
Geçerlilik Tarih Aralığı: $startDate - $endDate
Günlük Tahsis Edilen Oda Sayısı (Kontenjan): $allottedRooms
Oda Tipi: $roomType
Pansiyon Tipi: $boardType
Acente İndirim Oranı: Taahhüt edilen tarih aralığında OTEL’in aksine bir yazılı bildirimi olmaması durumunda, güncel kapı/liste fiyatı üzerinden %$commissionRate indirim uygulanacaktır.
Aksiyon/Erken Rezervasyon İndirimi: $actionDiscount

4. REZERVASYON, KONTENJAN VE STOP-SALE (SATIŞA KAPAMA) ESASLARI
Kontenjan Kullanımı: ACENTE, kendisine tahsis edilen kontenjan dahilinde OTEL’den ek onay almadan satış yapabilir. Kontenjan aşımı durumunda OTEL’in yazılı onayı zorunludur.
Release Period (Opsiyon Süresi): Kullanılmayan kontenjan odaları, giriş tarihinden $releaseDays gün önce OTEL’e iade edilmiş sayılır. OTEL bu tarihten sonra satılmayan odaları serbestçe satma hakkına sahiptir.
Stop-Sale (Satış Durdurma): OTEL, doluluk durumuna göre ACENTE’ye en az $stopSaleDays gün öncesinden yazılı (e-posta ile) bildirmek kaydıyla satışı durdurma (Stop-Sale) hakkına sahiptir. Bildirim tarihinden önce yapılmış ve onaylanmış rezervasyonlar bu durumdan etkilenmez.

5. ÖDEME VE İPTAL KOŞULLARI
Ödeme Şekli: ACENTE, gerçekleşen konaklamaların bedelini OTEL tarafından kesilecek fatura karşılığında $paymentTerm ödeyecektir.
İptal ve No-Show:
Giriş tarihine $cancellationDays gün kala yapılan iptallerde ceza uygulanmaz.
Bu süreden sonra yapılan iptallerde veya habersiz gelmeme (No-Show) durumunda 1 Gecelik konaklama tutarı ACENTE’ye fatura edilir.

6. GENEL HÜKÜMLER VE FESİH
Gizlilik: Taraflar, işbu sözleşmede yer alan özel fiyat ve indirim oranlarını 3. kişilerle paylaşamaz.
Sözleşmenin Feshi: Taraflardan birinin yükümlülüklerini ihlal etmesi durumunda, diğer taraf 7 gün öncesinden yazılı ihtar çekerek sözleşmeyi tek taraflı feshedebilir.
Uyuşmazlıklar: İşbu sözleşmeden doğabilecek uyuşmazlıklarda $courtCity Mahkemeleri ve İcra Daireleri yetkilidir.

7. ÖZEL HÜKÜMLER
${specialConditions.ifBlank { "Yoktur." }}

İşbu sözleşme $contractDate tarihinde 2 (iki) nüsha olarak tanzim edilmiş ve taraflarca imzalanmıştır.

OTEL YETKİLİSİ                                 ACENTE YETKİLİSİ
  İmza / Kaşe                                     İmza / Kaşe
        """.trimIndent()
    }

    val scrollState = rememberScrollState()

    Box(modifier = Modifier.fillMaxSize().background(Color(0xFFF8FAFC))) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .verticalScroll(scrollState)
                .verticalScrollbar(scrollState)
                .padding(16.dp)
                .padding(bottom = 80.dp)
        ) {
            // Acenta Seçim Kartı
            HFCard(modifier = Modifier.fillMaxWidth()) {
                Column(modifier = Modifier.padding(16.dp)) {
                    Text("1. Acente Seçimi", fontWeight = FontWeight.Bold, fontSize = 16.sp, color = Color(0xFF1E293B))
                    Spacer(Modifier.height(8.dp))
                    
                    Box(modifier = Modifier.fillMaxWidth()) {
                        OutlinedTextField(
                            value = selectedAgency?.name ?: if (agencies.isEmpty()) "Sistemde kayıtlı acente yok" else "Acente Seçiniz...",
                            onValueChange = {},
                            readOnly = true,
                            enabled = agencies.isNotEmpty(),
                            trailingIcon = {
                                IconButton(onClick = { if (agencies.isNotEmpty()) expandedDropdown = true }) {
                                    Icon(Icons.Default.ArrowDropDown, contentDescription = "Seç")
                                }
                            },
                            modifier = Modifier.fillMaxWidth(),
                            shape = RoundedCornerShape(10.dp)
                        )
                        DropdownMenu(
                            expanded = expandedDropdown,
                            onDismissRequest = { expandedDropdown = false }
                        ) {
                            agencies.forEach { agency ->
                                DropdownMenuItem(
                                    text = { Text(agency.name) },
                                    onClick = {
                                        selectedAgency = agency
                                        expandedDropdown = false
                                    }
                                )
                            }
                        }
                    }
                }
            }

            Spacer(Modifier.height(16.dp))

            // Manuel Girilecek Şartlar Kartı
            HFCard(modifier = Modifier.fillMaxWidth()) {
                Column(modifier = Modifier.padding(16.dp)) {
                    Text("2. Sözleşme Şartları ve Kontenjan", fontWeight = FontWeight.Bold, fontSize = 16.sp, color = Color(0xFF1E293B))
                    Spacer(Modifier.height(12.dp))

                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        OutlinedTextField(
                            value = startDate,
                            onValueChange = { startDate = it },
                            label = { Text("Başlangıç Tarihi") },
                            modifier = Modifier.weight(1f),
                            shape = RoundedCornerShape(10.dp)
                        )
                        OutlinedTextField(
                            value = endDate,
                            onValueChange = { endDate = it },
                            label = { Text("Bitiş Tarihi") },
                            modifier = Modifier.weight(1f),
                            shape = RoundedCornerShape(10.dp)
                        )
                    }

                    Spacer(Modifier.height(10.dp))

                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        OutlinedTextField(
                            value = allottedRooms,
                            onValueChange = { allottedRooms = it },
                            label = { Text("Oda Kontenjanı") },
                            modifier = Modifier.weight(1f),
                            shape = RoundedCornerShape(10.dp)
                        )
                        OutlinedTextField(
                            value = commissionRate,
                            onValueChange = { commissionRate = it },
                            label = { Text("İndirim/Komisyon (%)") },
                            modifier = Modifier.weight(1f),
                            shape = RoundedCornerShape(10.dp)
                        )
                    }

                    Spacer(Modifier.height(10.dp))

                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        OutlinedTextField(
                            value = roomType,
                            onValueChange = { roomType = it },
                            label = { Text("Oda Tipi") },
                            modifier = Modifier.weight(1f),
                            shape = RoundedCornerShape(10.dp)
                        )
                        OutlinedTextField(
                            value = boardType,
                            onValueChange = { boardType = it },
                            label = { Text("Pansiyon Tipi") },
                            modifier = Modifier.weight(1f),
                            shape = RoundedCornerShape(10.dp)
                        )
                    }

                    Spacer(Modifier.height(10.dp))

                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        OutlinedTextField(
                            value = releaseDays,
                            onValueChange = { releaseDays = it },
                            label = { Text("Release (Gün)") },
                            modifier = Modifier.weight(1f),
                            shape = RoundedCornerShape(10.dp)
                        )
                        OutlinedTextField(
                            value = stopSaleDays,
                            onValueChange = { stopSaleDays = it },
                            label = { Text("Stop-Sale İhbar (Gün)") },
                            modifier = Modifier.weight(1f),
                            shape = RoundedCornerShape(10.dp)
                        )
                    }

                    Spacer(Modifier.height(10.dp))

                    OutlinedTextField(
                        value = paymentTerm,
                        onValueChange = { paymentTerm = it },
                        label = { Text("Ödeme Şekli / Koşulu") },
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(10.dp)
                    )

                    Spacer(Modifier.height(14.dp))

                    // Özel Hükümler (Manuel Metin Alanı)
                    Text("3. Özel Hükümler (Serbest Metin)", fontWeight = FontWeight.Bold, fontSize = 14.sp, color = Color(0xFF1E293B))
                    Spacer(Modifier.height(6.dp))
                    OutlinedTextField(
                        value = specialConditions,
                        onValueChange = { specialConditions = it },
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(110.dp),
                        placeholder = { Text("Özel şartları veya ilave kuralları buraya yazabilirsiniz...") },
                        shape = RoundedCornerShape(10.dp)
                    )
                }
            }

            Spacer(Modifier.height(20.dp))

            // Resmi Sözleşme Belgesi Canlı Önizleme
            Text("Sözleşme Dokümanı Önizleme", fontWeight = FontWeight.Bold, fontSize = 16.sp, color = Color(0xFF1E293B))
            Spacer(Modifier.height(8.dp))

            Card(
                modifier = Modifier
                    .fillMaxWidth()
                    .border(1.dp, Color(0xFFCBD5E1), RoundedCornerShape(12.dp)),
                colors = CardDefaults.cardColors(containerColor = Color.White),
                shape = RoundedCornerShape(12.dp)
            ) {
                Column(modifier = Modifier.padding(16.dp)) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Default.Description, contentDescription = null, tint = Color(0xFF2196F3))
                        Spacer(Modifier.width(8.dp))
                        Text("RESMİ SÖZLEŞME METNİ", fontWeight = FontWeight.Bold, color = Color(0xFF0F172A), fontSize = 14.sp)
                    }
                    HorizontalDivider(modifier = Modifier.padding(vertical = 12.dp), color = Color(0xFFE2E8F0))
                    Text(
                        text = fullContractText,
                        fontSize = 12.sp,
                        color = Color(0xFF334155),
                        lineHeight = 18.sp
                    )
                }
            }
        }

        // Bottom Bar
        Surface(
            modifier = Modifier
                .align(Alignment.BottomCenter)
                .fillMaxWidth(),
            color = Color.White,
            shadowElevation = 8.dp
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(16.dp),
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                OutlinedButton(
                    onClick = {
                        clipboardManager.setText(AnnotatedString(fullContractText))
                        showSnackbar = true
                    },
                    modifier = Modifier.weight(1f).height(48.dp),
                    shape = RoundedCornerShape(12.dp)
                ) {
                    Icon(Icons.Default.ContentCopy, contentDescription = null, modifier = Modifier.size(18.dp))
                    Spacer(Modifier.width(6.dp))
                    Text("Metni Kopyala")
                }
                Button(
                    onClick = {
                        clipboardManager.setText(AnnotatedString(fullContractText))
                        showSnackbar = true
                    },
                    modifier = Modifier.weight(1f).height(48.dp),
                    shape = RoundedCornerShape(12.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF2196F3))
                ) {
                    Icon(Icons.Default.Print, contentDescription = null, modifier = Modifier.size(18.dp))
                    Spacer(Modifier.width(6.dp))
                    Text("Hazırla / Yazdır")
                }
            }
        }

        if (showSnackbar) {
            Snackbar(
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .padding(bottom = 80.dp, start = 16.dp, end = 16.dp),
                action = {
                    TextButton(onClick = { showSnackbar = false }) {
                        Text("Tamam", color = Color.White)
                    }
                }
            ) {
                Text("Sözleşme metni panoya kopyalandı!")
            }
        }
    }
}
